import React from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Header from 'components/Navigation/SideBar/Header';
import Item from 'components/Navigation/SideBar/Item';
import closeIcon from 'assets/icons/close.svg';
import sideBarRoutes from 'utils/routes/sideBarRoutes';

import { shallowEqual, useSelector } from 'react-redux';
import { selectAuthenticatedUserState } from 'state/selectors/auth';
import getPathsByPermission from 'utils/users/getPathsByPermission';
import classes from './SideBar.module.scss';

const SideBar = ({ open, onToggleMenu }) => {
  const location = useLocation();

  const { user } = useSelector(selectAuthenticatedUserState, shallowEqual);
  const userRoutes = getPathsByPermission(user.permissions);
  userRoutes.push('/login');

  const filteredSideBarRoutes = sideBarRoutes.filter(route => 
    (userRoutes.includes(route.to) || userRoutes.includes(route.pathname))
  );

  return (
    <>
      <aside
        className={classNames(classes.content, {
          [classes.open]: open,
          [classes.close]: !open,
        })}
      >
        <div className={classes.header}>
          <button
            type="button"
            className={classes.closeButton}
            onClick={onToggleMenu}
          >
            <img src={closeIcon} alt="close" />
          </button>
          <Header />
        </div>
        {filteredSideBarRoutes.map(({ title, to, pathname }) => (
          <Item
            key={title}
            title={title}
            to={to}
            selected={location.pathname === pathname}
          />
        ))}
      </aside>
      {open && (
        <div
          name="background"
          role="button"
          className={classes.background}
          aria-label="background"
          onClick={onToggleMenu}
          onKeyDown={onToggleMenu}
          tabIndex={0}
        />
      )}
      <button
        type="button"
        className={classes.iconButton}
        onClick={onToggleMenu}
      >
        <div className={classes.menuIcon} />
        <div className={classes.menuIcon} />
        <div className={classes.menuIcon} />
      </button>
    </>
  );
};

SideBar.propTypes = {
  open: PropTypes.bool.isRequired,
  onToggleMenu: PropTypes.func.isRequired,
};

export default SideBar;
